import { useMemo } from 'react'
// routes
import { paths } from 'src/routes/paths'
// locales
// components
import Iconify from 'src/components/iconify'
import { useUserStore } from 'src/store/user'

// ----------------------------------------------------------------------

const icon = (name: string) => <Iconify icon={name} />

const ICONS = {
  user: icon('carbon:user-data'),
  dashboard: icon('carbon:dashboard'),
  products: icon('carbon:inventory-management'),
  stock: icon('carbon:box'),
  reports: icon('carbon:report'),
  events: icon('carbon:calendar'),
  orders: icon('carbon:shopping-cart'),
  analytics: icon('carbon:analytics'),
  cashless: icon('carbon:wallet'),
  performance: icon('carbon:chart-line'),
  ticketValidation: icon('carbon:qr-code'),
  fechamento: icon('carbon:document'),
  audit: icon('carbon:security'),
  finance: icon('carbon:finance'),
}

// ----------------------------------------------------------------------

export function useNavData() {
  const { user } = useUserStore()

  const data = useMemo(
    () => {
      const sections = [
      // Grupo Principal - Visão Geral
      {
        subheader: 'Visão Geral',
        items: [{ title: 'Início', path: paths.dashboard.root, icon: ICONS.dashboard }],
      },

      // Grupo Gestão - Configuração e Administração
      {
        subheader: 'Gestão',
        items: [
          { title: 'Usuários', path: paths.dashboard.user, icon: ICONS.user },
          { title: 'Eventos', path: paths.dashboard.events.root, icon: ICONS.events },
          { title: 'Estoque', path: paths.dashboard.stock, icon: ICONS.stock },
        ],
      },

      // Grupo Vendas - Operações comerciais
      {
        subheader: 'Vendas',
        items: [
          { title: 'Vendas', path: paths.dashboard.orders, icon: ICONS.orders },
          { title: 'CashLess', path: paths.dashboard.transaction.root, icon: ICONS.cashless },
          {
            title: 'Validação de Tickets',
            path: paths.dashboard.events.ticketValidation,
            icon: ICONS.ticketValidation,
          },
        ],
      },

      // Grupo Relatórios - Análises de vendas e desempenho
      {
        subheader: 'Relatórios',
        items: [
          { title: 'Vendas Gerais', path: paths.dashboard.reports, icon: ICONS.reports },
          {
            title: 'Performance Vendedores',
            path: paths.dashboard.sellerPerformance,
            icon: ICONS.performance,
          },
          {
            title: 'Vendas por Produto',
            path: paths.dashboard.productsAnalysis,
            icon: ICONS.analytics,
          },
          {
            title: 'Resumão',
            path: paths.dashboard.fechamento,
            icon: ICONS.fechamento,
          },
        ],
      },
      ]

      if (user?.role === 'admin') {
        sections.push({
          subheader: 'Administração',
          items: [
            {
              title: 'Portal da Transparência',
              path: paths.dashboard.audit,
              icon: ICONS.audit,
            },
            {
              title: 'Financeiro',
              path: paths.dashboard.finance,
              icon: ICONS.finance,
            },
          ],
        })
      }

      return sections
    },
    [user?.role],
  )

  return data
}
